import * as React from 'react';

import styled from 'styled-components';
import { JRCEllipsis } from '../../JRCEllipsis/JRCEllipsis';

export const CSSTitle = styled.div`
    display: flex;
    flex: 1;
    padding: 12px 0;
`;

export const CSSTitleA = styled.a`
    display: flex;
    flex: 1;
    padding: 12px 0;
`;

export const EntityItemTitle = ({
    title,
    type,
    url,
    useNavigation = true,
    onClick,
}: {
    title: string;
    type: string;
    url?: string;
    useNavigation: boolean;
    onClick: () => void;
}) => {
    if (type === 'folder' || type === 'group') {
        return useNavigation ? (
            <CSSTitle onClick={onClick}>
                <JRCEllipsis length={30} label={title} />
            </CSSTitle>
        ) : (
            <CSSTitleA href={url} target="_blank">
                <JRCEllipsis length={30} label={title} />
            </CSSTitleA>
        );
    }

    return useNavigation ? (
        <CSSTitle>
            <JRCEllipsis length={30} label={title} />
        </CSSTitle>
    ) : (
        <CSSTitleA href={url} target="_blank">
            <JRCEllipsis length={30} label={title} />
        </CSSTitleA>
    );
};
